import { render, staticRenderFns } from "./ModalItemCard.vue?vue&type=template&id=fc578cc4&scoped=true"
import script from "./ModalItemCard.vue?vue&type=script&lang=js"
export * from "./ModalItemCard.vue?vue&type=script&lang=js"
import style0 from "./ModalItemCard.vue?vue&type=style&index=0&id=fc578cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc578cc4",
  null
  
)

export default component.exports